// Styles for DropDownComponent go here.
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledDropDownComponent = styled.div`
  .m-dropdown-content {
    height: fit-content !important;
    max-height: ${toRem(480)} !important;
    @media ${baseVariables.mediaQuery.md} {
      max-height: ${toRem(360)} !important;
    }
  }

  .icon-selected,
  .icon-check {
    font-weight: 800;
  }

  .m-dropdown-header {
    .header-heading {
      text-transform: none;
      color: ${contextualVariable.brandedFontColor};
      font-weight: 400;
      font-size: ${toRem(12)};
    }
    position: sticky;
    top: 0;
    background: ${baseVariables.color['base20']};
    z-index: 2;
    padding: ${toRem(32)} ${toRem(24)};
    border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']} !important;
  }

  .m-dropdown-container {
    border: ${toRem(1)} solid ${baseVariables.color['neutral40']} !important;
    @media ${baseVariables.mediaQuery.md} {
      border-radius: unset;
      position: relative;
    }
  }

  .dropdown-to-modal {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  @media ${baseVariables.mediaQuery.md} {
    .dropdown-container {
      z-index: 1;
      position: absolute;
      width: calc(100% - ${toRem(16)});
      top: ${toRem(45)};
    }
  }

  .hover-class {
    &:hover {
      background: ${baseVariables.color['neutral10']};
    }
  }
`;
